export default __webpack_public_path__ + "images/SM.0d0b408.png";